<template>
  <div>
    <el-select
      :disabled="disabled"
      :style="{ width }"
      :size="size"
      v-model="inputAcount"
      filterable
      clearable
      :placeholder="'请选择' + (typeConfig.prefix || '') + objUrl.tiile"
      :filter-method="fetchOptions"
      @change="handleChange"
    >
      <el-option
        v-for="item in optionsList"
        :key="item[typeConfig.valueKey]"
        :label="item[typeConfig.labelKey]"
        :value="item[typeConfig.valueKey]"
      />
    </el-select>
  </div>
</template>

<script>
import apiBaseUrl from "../../config/api";
import axios from "axios";

const TYPE_CONFIG = {
  来源: {
    searchParam: 'sourceName',
    labelKey: 'sourceName',
    valueKey: 'sourceId',
    getData: (res) => res.data.list,
  },
  来源负责人: {
    searchParam: 'sourcepeopleName',
    labelKey: 'sourcepeopleName',
    valueKey: 'sourcepeopleId',
    getData: (res) => res.data.list,
  },
  老师: {
    searchParam: 'teacherName',
    labelKey: 'teacherName',
    valueKey: 'id',
    prefix: 'IP',
    getData: (res) => res.data,
  },
};

export default {
  props: {
    objUrl: {
      type: Object,
      default: () => ({}),
    },
    size: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    values: {
      type: [String, Number],
      default: '',
    },
  },

  data() {
    return {
      inputAcount: '',
      optionsList: [],
    };
  },

  computed: {
    typeConfig() {
      return TYPE_CONFIG[this.objUrl.tiile] || {};
    },
  },

  watch: {
    values(newVal) {
      this.inputAcount = newVal;
    },
  },

  mounted() {
    this.fetchOptions();
  },

  methods: {
    childMethod() {
      this.inputAcount = '';
      this.fetchOptions();
      this.$emit('handleChangeSelect', this.objUrl.keys, '');
    },

    handleChange(value) {
      this.$emit('handleChangeSelect', this.objUrl.keys, value);
    },

    fetchOptions(keyword = '') {
      const { searchParam, getData } = this.typeConfig;
      if (!searchParam || !this.objUrl.selectList) return;

      axios
        .get(`${apiBaseUrl}${this.objUrl.selectList}?${searchParam}=${keyword}`, {
          headers: { authorization: sessionStorage.getItem('tokenInfo') },
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.optionsList = getData(res.data) || [];
          } else {
            this.optionsList = [];
          }
        });
    },
  },
};
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/manager/selectcomtent.vue